<template>
  <v2-container v-if="teams[$route.params.team].account">
    <v-delete-modal
      name="delete-clients-modal"
      :title="
        $t('modals.deleteClient.title', {
          name: $h.getNameFromClientsByUid(currentDeleteClientUid, clients),
        })
      "
      :text="$t('modals.deleteClient.text')"
      :deleteHandler="
        () => {
          deleteModalHandler(currentDeleteClientUid);
        }
      "
    >
    </v-delete-modal>
    <v-delete-modal
      name="delete-filterPresets-modal"
      :title="
        currentDeleteFilterPreset
          ? $h.formatFilterPresetName(currentDeleteFilterPreset, teams[$route.params.team].account.locale)
          : ''
      "
      :text="$t('modals.deleteFilterPreset.text')"
      :deleteHandler="
        () => {
          deleteFilterPresetModalHandler('clients', setClientsFilters);
        }
      "
    >
    </v-delete-modal>
    <modal
      name="saveFilterPreset"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">{{ $t("titles.saveFilterPreset") }}</div>
        <div class="modal-content">
          <form @submit.prevent>
            <v-textfield
              :label="$t('labels.giveFilterPresetName')"
              v-model="filterPresetName"
              v-validate="'required'"
              name="title"
            ></v-textfield>
          </form>
        </div>
        <div class="modal-buttons">
          <a class="v1 simple" @click="$modal.hide('saveFilterPreset')">{{ $t("actions.cancel") }}</a>
          <v-button primary @click.native="saveFilterPreset('clients')">{{
            $t("actions.createFilterPreset")
          }}</v-button>
          <v-button
            primary
            @click.native="saveFilterPreset('clients', true)"
            :active="
              !!(
                teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset &&
                !teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset.is_global
              )
            "
          >
            {{ $t("actions.editFilterPreset") }}</v-button
          >
        </div>
      </div>
    </modal>
    <modal
      name="start-clients-sync"
      class="envivo-modal"
      @before-open="$h.toggleHtmlScroll"
      @before-close="$h.toggleHtmlScroll"
      transition="pop-out"
      height="auto"
      adaptive
      :maxWidth="600"
      width="90%"
      scrollable
    >
      <div class="modal-wrapper">
        <div class="modal-title">{{ $t("clientSyncs.modal.title") }}</div>
        <div class="relative">
          <div class="modal-content">
            {{ $t("clientSyncs.modal.content") }}
          </div>
          <div class="modal-buttons">
            <a class="v1 simple" @click="$modal.hide('start-clients-sync')">{{ $t("actions.cancel") }}</a>
            <v-button primary @click.native="startClientSync()">{{ $t("clientSyncs.modal.startClientSync") }}</v-button>
          </div>
        </div>
      </div>
    </modal>
    <v2-row>
      <v2-col col12>
        <v2-header-bar :titles="[{ label: $t('titles.clients') }]">
          <template v-slot:title>
            <v2-tooltip
              class="ml-2"
              :title="$t('tips.title')"
              :content="$t('tips.global.search') + '<br/>' + $t('tips.clients.addClient')"
              v-if="showAlways || showTips"
              :show="showTips"
            ></v2-tooltip>
          </template>
          <template v-slot:left>
            <v2-search
              :placeholder="$t('placeholders.searchClient')"
              maxWidth
              @reset="search('clients', getClients)"
              @submit="search('clients', getClients)"
              v-model="searchQuery"
            ></v2-search>
          </template>
          <template v-slot:right>
            <v2-button :title="$t('labels.newClient')" round icon primary @click.native="$goTo('createClient')"
              ><v2-icon :data="require('@icon/Icon=plus.svg')"></v2-icon
            ></v2-button>
          </template>
        </v2-header-bar>
      </v2-col>
    </v2-row>
    <v-row class="mb-0" v-if="filterPresets && filterPresets.length > 0">
      <v-col stretch>
        <div class="flex flex-wrap">
          <div v-for="preset in filterPresets" :key="preset.name">
            <v-button
              lavender
              small
              @click.native="selectFilterPreset(preset)"
              v-if="preset.is_global"
              class="combi-btn"
              :selected="
                teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset &&
                preset.uid === teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset.uid
              "
              >{{ $h.formatFilterPresetName(preset, teams[$route.params.team].account.locale) }}</v-button
            >
            <v-combi-button
              v-if="!preset.is_global"
              :selected="
                teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset &&
                preset.uid === teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset.uid
              "
              :first="{
                lavender: true,
                small: true,
                onClick: () => {
                  selectFilterPreset(preset);
                },
              }"
              :second="{
                lavender: true,
                hoverDanger: true,
                small: true,
                icon: 'Icon=x.svg',
                onClick: () => {
                  showDeleteFilterPresetModal(preset);
                },
              }"
              >{{ $h.formatFilterPresetName(preset, teams[$route.params.team].account.locale) }}</v-combi-button
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="teamsSettings[$route.params.team] && teamsSettings[$route.params.team].listsSettings.clients.filterActive"
    >
      <v-col stretch>
        <v-card custom class="p-6">
          <div slot="content" class="flex flex-row sm:flex-row w-full justify-between">
            <div>
              <div class="flex">
                <div class="text-grey-lavender mb-1">
                  {{
                    !teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset
                      ? $t("filters.results")
                      : $h.formatFilterPresetName(
                          teamsSettings[$route.params.team].listsSettings.clients.currentFilterPreset
                        )
                  }}
                </div>
                <div
                  class="text-danger ml-1"
                  v-if="teamsSettings[$route.params.team].listsSettings.clients.currentFilterPresetHasChanged"
                >
                  &#42;
                </div>
              </div>
              <h6>
                {{
                  $tc(
                    "filters.clientsResult",
                    teamsSettings[$route.params.team].listsSettings.clients.pagination.total,
                    {
                      result: teamsSettings[$route.params.team].listsSettings.clients.pagination.total,
                    }
                  )
                }}
              </h6>
            </div>
            <div>
              <v-button class="mt-4 sm:mt-0 mr-2" attention @click.native="resetFilters(setClientsFilters, 'clients')">
                {{ $t("filters.resetFilter") }}</v-button
              >
              <v-button primary @click.native="showSaveFilterPresetModal('clients')">
                {{ $t("actions.saveFilterPreset") }}</v-button
              >
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="clients && teamsSettings[$route.params.team]">
      <v-col class="col-12">
        <v-list-header complex>
          <v-list-header-cell emptyIcon />
          <v-list-header-cell
            size="3"
            :showAs="$t('client.name')"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="sortMainColDropdown"
          />
          <v-list-header-cell
            :withTooltip="showAlways || showTips"
            :tooltip="{
              content: $t('tips.global.sortList'),
              title: $t('tips.title'),
              showTooltip: showTips,
            }"
            :showAs="$t(teamsSettings[$route.params.team].listsSettings.clients.showAs.firstCol.label)"
            :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.firstCol.size"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="showAsFirstColDropdown"
          />
          <v-list-header-cell
            :showAs="$t(teamsSettings[$route.params.team].listsSettings.clients.showAs.secondCol.label)"
            tabletHidden
            :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.secondCol.size"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="showAsSecondColDropdown"
          />
          <v-list-header-cell
            :showAs="$t(teamsSettings[$route.params.team].listsSettings.clients.showAs.thirdCol.label)"
            dropdownRight
            :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.thirdCol.size"
            :showAsDropdownUid="$h.createUniqueUid()"
            :showAsDropdown="showAsThirdColDropdown"
          />
          <v-list-header-cell
            :mobile="$t('actions.sort')"
            :mobileDropdownUid="$h.createUniqueUid()"
            :mobileDropdown="mobileDropdown"
          />
          <v-list-header-cell
            :withTooltip="showAlways || showTips"
            :tooltip="{
              content: $t('tips.clients.useFilters'),
              title: $t('tips.title'),
              showTooltip: showTips,
            }"
            filter
            dropdownRight
            multiselect
            :filterActive="teamsSettings[$route.params.team].listsSettings.clients.filterActive"
            :filterDropdownUid="$h.createUniqueUid()"
            :filterDropdown="filterDropdown"
          />
        </v-list-header>
        <ul class="list">
          <router-link
            :to="{ name: 'Client', params: { uid: client.uid } }"
            v-for="client in clients"
            :key="client.uid"
          >
            <v-list-item complex hover>
              <v-list-cell
                icon="Icon=folder-client.svg"
                class="folder-client-icon"
                iconFill
                iconColor="#5057af"
                iconHeight="18"
              />
              <v-list-cell
                :title="$h.formatName(client)"
                size="3"
                :mobileSubtitle="
                  client.company ? client.company + ' • ' + client.projects_count : client.projects_count
                "
              />
              <v-list-cell
                :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.firstCol.size"
                :value="
                  $h.formatValue(
                    teamsSettings[$route.params.team].listsSettings.clients.showAs.firstCol.format,
                    client[teamsSettings[$route.params.team].listsSettings.clients.showAs.firstCol.key],
                    teams[$route.params.team].account.timezone
                  )
                "
              />
              <v-list-cell
                :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.secondCol.size"
                tabletHidden
                :value="
                  $h.formatValue(
                    teamsSettings[$route.params.team].listsSettings.clients.showAs.secondCol.format,
                    client[teamsSettings[$route.params.team].listsSettings.clients.showAs.secondCol.key],
                    teams[$route.params.team].account.timezone
                  )
                "
              />
              <v-list-cell
                :size="teamsSettings[$route.params.team].listsSettings.clients.showAs.thirdCol.size"
                :value="
                  $h.formatValue(
                    teamsSettings[$route.params.team].listsSettings.clients.showAs.thirdCol.format,
                    client[teamsSettings[$route.params.team].listsSettings.clients.showAs.thirdCol.key],
                    teams[$route.params.team].account.timezone
                  )
                "
              />
              <v-list-cell
                iconDropdown
                grey
                icon="Icon=more-horizontal.svg"
                iconColor="#5057af"
                :dropdownData="moreDropdown"
                :dropdownUid="$h.createUniqueUid()"
                :dropdownValue="client.uid"
              />
            </v-list-item>
          </router-link>
          <v-list-item v-if="!clients.length">
            <v-list-cell :value="$t('placeholders.noClients')"></v-list-cell>
          </v-list-item>
        </ul>
        <v-list-pagination
          :currentPage="teamsSettings[$route.params.team].listsSettings.clients.pagination.page"
          :showPerPage="teamsSettings[$route.params.team].listsSettings.clients.pagination.perPage"
          :totalPages="teamsSettings[$route.params.team].listsSettings.clients.pagination.lastPage"
          :apiCall="
            (page, perPage) => {
              changeClientsPage(page, perPage);
            }
          "
        >
        </v-list-pagination>
      </v-col>
    </v-row>
    <v-row>
      <div class="px-4 pb-8 flex justify-between w-full">
        <div class="flex">
          <router-link class="simple" :to="{ name: 'createImport' }">{{ $t("actions.importClients") }}</router-link>
          <v2-tooltip
            class="ml-2"
            :title="$t('tips.title')"
            :content="$t('tips.clients.importClients')"
            v-if="showAlways || showTips"
            :show="showTips"
          ></v2-tooltip>
        </div>
        <div class="flex flex-col">
          <div>
            <v-button
              primary
              v-if="teams[$route.params.team].account.team.attributes.client_sync"
              class="mb-3"
              @click.native="$modal.show('start-clients-sync')"
              >{{ $t("clientSyncs.actions.sync") }}</v-button
            >
          </div>
          <router-link
            v-if="teams[$route.params.team].account.team.attributes.client_sync"
            class="simple"
            :to="{ name: 'ClientSyncsList' }"
            >{{ $t("clientSyncs.actions.goToList") }}</router-link
          >
        </div>
      </div>
    </v-row>
  </v2-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import clients from "@/mixins/dropdowns/clients.js";
import filterPresets from "@/mixins/filterPresets.js";

export default {
  name: "Clients",
  mixins: [listSettings, clients, filterPresets],
  data() {
    return {
      currentDeleteClientUid: null,
      searchQuery: "",
      moreDropdown: [
        {
          options: [
            {
              label: this.$t("actions.edit"),
              method: (uid) => {
                this.$goTo("editClient", { uid: uid });
              },
              doNotShowActiveState: true,
            },
            {
              label: this.$t("actions.delete"),
              method: (uid) => {
                this.showDeleteModal(uid);
              },
              color: "text-danger",
              doNotShowActiveState: true,
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadPageData();
    if (
      this.teamsSettings[this.$route.params.team] &&
      this.teamsSettings[this.$route.params.team].listsSettings.clients.search
    )
      this.searchQuery = this.teamsSettings[this.$route.params.team].listsSettings.clients.search;
  },
  methods: {
    ...mapActions([
      "getClientList",
      "setListsSettings",
      "deleteClient",
      "syncClientList",
      "toggleDropdown",
      "getTeamTags",
      "getFilterPresets",
      "getFilterPreset",
      "createFilterPreset",
      "editFilterPreset",
      "deleteFilterPreset",
      "setCurrentFilterPreset",
      "setCurrentFilterPresetHasChanged",
    ]),
    loadPageData() {
      const vm = this;
      this.loadFilterPresets("clients");
      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      const p = {
        search: vm.teamsSettings[vm.$route.params.team].listsSettings.clients.search,
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.clients.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.clients.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.clients.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.clients.order.dir,
      };
      const params = vm.setFilterRequestObjectFromStore("clients", p);
      vm.getClientList({
        setListsSettings: true,
        params,
      })
        .then(() => {
          vm.getTeamTags({ params: { per_page: "1000" } })
            .then(() => {
              vm.initSort("clients");
              vm.initShowAs("clients");
              vm.initFilters("clients");
              vm.setDropdownOptions();
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            })
            .catch(() => {
              vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
            });
        })
        .catch(() => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
        });
    },
    sortClients(col, dir) {
      const params = {
        search: this.searchQuery,
        page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.page,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.perPage,
        order_col: col,
        order_dir: dir,
      };
      this.getClients(params);
    },
    changeClientsPage(page, perPage) {
      const params = {
        search: this.searchQuery,
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir,
      };
      this.getClients(params);
    },
    setClientsFilters() {
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir,
      };
      this.getClients(params);
      this.$eventbus.$emit("closeAllDropdowns");
    },
    getClients(params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.active && option.switch && option.switch.name && !option.select) {
          params[option.switch.name] = option.switch.model;
        }
        if (option.active && option.select && !option.select.custom) {
          params[option.select.name] = this.transformModelToRequestArray(option.select.model);
        }
      });
      this.getClientList({
        setListsSettings: true,
        params,
      }).then(() => {
        this.checkCurrentFilterPresetHasChanged("clients");
        this.initSort("clients");
      });
    },
    showDeleteModal(uid) {
      this.currentDeleteClientUid = uid;
      this.$modal.show("delete-clients-modal");
    },
    deleteModalHandler(uid) {
      this.currentDeleteClientUid = null;
      this.$modal.hide("delete-clients-modal");
      this.deleteClient({ client: uid })
        .then(() => {
          const params = {
            search: this.teamsSettings[this.$route.params.team].listsSettings.clients.search,
            page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.page,
            per_page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.perPage,
            order_col: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col,
            order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir,
          };
          this.getClients(params);
          this.$snotify.success(this.$t("toasts.deleteClient.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteClient.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    selectFilterPreset(preset) {
      const vm = this;
      const params = {
        search: this.searchQuery,
        page: 1,
        per_page: this.teamsSettings[this.$route.params.team].listsSettings.clients.pagination.perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir,
      };
      Object.assign(params, preset.value);
      this.getClientList({
        setListsSettings: true,
        params,
      }).then(() => {
        vm.setCurrentFilterPresetHasChanged({ list: "clients", state: false });
        vm.setCurrentFilterPreset({ list: "clients", filterPreset: preset });
        this.$modal.hide("showFilterPresets");
        vm.initSort("clients");
        vm.initShowAs("clients");
        vm.initFilters("clients");
      });
    },
    startClientSync() {
      const vm = this;
      vm.syncClientList()
        .then(() => {
          vm.$modal.hide("start-clients-sync");
          this.$snotify.success(this.$t("clientSyncs.toasts.startSync.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("clientSyncs.toasts.startSync.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    resetSearch() {},
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      clients: "clients_get_client_list",
      teamTags: "teams_get_tags",
      filterPresets: "filterpresets_get_filterpresets",
      showTips: "global_get_show_tips",
      showAlways: "global_get_show_tips_icon",
    }),
  },
};
</script>
